"use client";
import { jsxs, Fragment, jsx } from "react/jsx-runtime";
import { useExternalPopupConfig } from "../../../../utils/ExternalPopupConfigProvider/ExternalPopupConfigProviderClient.js";
import { isAbsoluteUrl } from "../../../../utils/index.js";
import { useState } from "react";
import { ExternalLinkModal } from "../ExternalLinkModal/index.js";
const MarkdownExternalLinkHandler = ({
  children,
  href,
  ...props
}) => {
  const [externalLinkModal, setExternalLinkModal] = useState({
    isOpen: false,
    href: null,
    setOpen: (isOpen) => setExternalLinkModal({ ...externalLinkModal, isOpen }),
    onCloseHandler: () => setExternalLinkModal({ ...externalLinkModal, isOpen: false })
  });
  const { externalLinkTranslations, internalDomains } = useExternalPopupConfig();
  const isExternalLink = href && isAbsoluteUrl(href) && !internalDomains.some((regex) => RegExp(regex).test(href));
  if (isExternalLink) {
    return /* @__PURE__ */ jsxs(Fragment, { children: [
      /* @__PURE__ */ jsx(
        "a",
        {
          href,
          onClick: (e) => {
            e.preventDefault();
            setExternalLinkModal({
              ...externalLinkModal,
              isOpen: true
            });
          },
          ...props,
          children
        }
      ),
      /* @__PURE__ */ jsx(
        ExternalLinkModal,
        {
          ...externalLinkModal,
          translations: externalLinkTranslations || {},
          href
        }
      )
    ] });
  }
  return /* @__PURE__ */ jsx("a", { href, ...props, children });
};
export {
  MarkdownExternalLinkHandler
};
